export const localText = {
  registryRequestFailedTitle: 'Registry request failed',
  loadingTitle: 'Loading data governors',
} as const
